/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayName: NonNullable<unknown> }} Payment_Overdue_MessageInputs */

const en_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We couldn't recover your credentials for ${i?.displayName} since the payment is overdue.`)
};

const id_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kami tidak dapat memulihkan kredensial Anda untuk ${i?.displayName} karena pembayaran lewat jatuh tempo.`)
};

const ms_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kami tidak dapat memulihkan bukti kelayakan anda untuk ${i?.displayName} oleh kerana pembayaran telah tertunggak.`)
};

const ca_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No hem pogut recuperar les teves credencials per ${i?.displayName}, ja que el pagament ha vençut.`)
};

const cs_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vaše přihlašovací údaje pro ${i?.displayName} se nám nepodařilo obnovit, protože jste v prodelní s platbou.`)
};

const da_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vi kunne ikke gendanne dine legitimationsoplysninger til ${i?.displayName}, da betalingen er forsinket.`)
};

const de_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wir konnten deine Zugangsdaten für ${i?.displayName} nicht wiederherstellen, weil die Zahlung überfällig ist.`)
};

const et_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Me ei saanud teie teenuse ${i?.displayName} mandaate taastada, kuna makse on tähtaja ületanud.`)
};

const es_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No pudimos obtener tus credenciales de ${i?.displayName} porque la suscripción está vencida.`)
};

const fr_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nous n’avons pas pu récupérer vos identifiants pour ${i?.displayName}, car le paiement n’a pas été effectué.`)
};

const hr_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nismo mogli vratiti vaše vjerodajnice za ${i?.displayName} jer plaćanje kasni.`)
};

const it_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Non siamo riusciti a recuperare le tue credenziali per ${i?.displayName} perché il pagamento è in ritardo.`)
};

const lv_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mums neizdevās atjaunot jūsu piekļuvi produktam ${i?.displayName}, jo maksājums ir nokavēts.`)
};

const lt_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Negalėjome atkurti prieigos prie ${i?.displayName}, nes vėluojama atlikti mokėjimą.`)
};

const hu_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nem sikerült visszaállítani az Ön hitelesítő adatait a ${i?.displayName} szolgáltatáshoz, mivel a fizetés késedelmes.`)
};

const nl_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We konden je inloggegevens voor ${i?.displayName} niet ophalen vanwege een achterstallige betaling.`)
};

const nb_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vi kunne ikke gjenopprette ${i?.displayName}-brukeren din fordi betalingsfristen har forfalt.`)
};

const pl_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nie mogliśmy odzyskać Twoich danych uwierzytelniających dla ${i?.displayName} z powodu zaległej płatności.`)
};

const pt_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível recuperar suas credenciais para ${i?.displayName}, pois o pagamento está atrasado.`)
};

const ro_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nu am putut recupera datele tale de identificare pentru ${i?.displayName} deoarece plata este întârziată.`)
};

const sk_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nemohli sme obnoviť vaše údaje pre ${i?.displayName}, pretože platba je po lehote splatnosti.`)
};

const sl_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vaših poverilnic za »${i?.displayName}« nismo mogli obnoviti, ker naročnina ni plačana.`)
};

const fi_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Emme voineet palauttaa tunnuksiasi kohteelle ${i?.displayName}, koska maksu on erääntynyt.`)
};

const sv_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vi kunde inte återställa dina inloggningsuppgifter för ${i?.displayName} eftersom betalningen är försenad.`)
};

const vi_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chúng tôi không thể khôi phục thông tin đăng nhập của bạn cho ${i?.displayName} vì đã quá hạn thanh toán.`)
};

const tr_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonelik bedeli ödemesi geciktiğinden ${i?.displayName} için kimlik bilgilerinizi kurtaramadık.`)
};

const el_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Δεν μπορέσαμε να ανακτήσουμε τα διαπιστευτήριά σας για το ${i?.displayName}, καθώς η πληρωμή έχει καθυστερήσει.`)
};

const bg_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не успяхме да възстановим твоите идентификационни данни за ${i?.displayName}, тъй като плащането е просрочено.`)
};

const ru_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Мы не смогли восстановить ваши учетные данные для ${i?.displayName}, поскольку платеж просрочен.`)
};

const sr_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Нисмо успели да вратимо ваше акредитиве за функцију ${i?.displayName} јер плаћање касни.`)
};

const uk_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ми не змогли відновити ваші облікові дані для ${i?.displayName}, оскільки платіж було прострочено.`)
};

const ka_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ჩვენ ვერ აღვადგინეთ თქვენი ${i?.displayName}-ის ავტორიზაციის მონაცემები, რადგან გადახდა ვადაგადაცილებულია.`)
};

const hi_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`पेमेंट की तिथि समाप्त हो जाने के कारण हम ${i?.displayName} के लिए आपके क्रेडेंशियल रिकवर नहीं कर सके.`)
};

const th_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เราไม่สามารถกู้คืนข้อมูลประจำตัวของคุณสำหรับ ${i?.displayName} ได้ เนื่องจากมียอดค้างชำระ`)
};

const ko_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`구독 요금이 연체되어 ${i?.displayName}에 대한 자격 증명을 복원할 수 없습니다.`)
};

const zh_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`我们无法恢复您的 ${i?.displayName} 凭据，因为该支付已逾期。`)
};

const zh_tw_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`由於訂閱尚未付款，我們無法為 ${i?.displayName} 取回您的認證資料。`)
};

const ja_payment_overdue_message = /** @type {(inputs: Payment_Overdue_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`支払い期限が過ぎているため、 ${i?.displayName} の認証情報を回復できませんでした。`)
};

/**
* | output |
* | --- |
* | "We couldn't recover your credentials for {displayName} since the payment is overdue." |
*
* @param {Payment_Overdue_MessageInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const payment_overdue_message = /** @type {((inputs: Payment_Overdue_MessageInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Overdue_MessageInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_payment_overdue_message(inputs)
	if (locale === "ms") return ms_payment_overdue_message(inputs)
	if (locale === "ca") return ca_payment_overdue_message(inputs)
	if (locale === "cs") return cs_payment_overdue_message(inputs)
	if (locale === "da") return da_payment_overdue_message(inputs)
	if (locale === "de") return de_payment_overdue_message(inputs)
	if (locale === "et") return et_payment_overdue_message(inputs)
	if (locale === "es") return es_payment_overdue_message(inputs)
	if (locale === "fr") return fr_payment_overdue_message(inputs)
	if (locale === "hr") return hr_payment_overdue_message(inputs)
	if (locale === "it") return it_payment_overdue_message(inputs)
	if (locale === "lv") return lv_payment_overdue_message(inputs)
	if (locale === "lt") return lt_payment_overdue_message(inputs)
	if (locale === "hu") return hu_payment_overdue_message(inputs)
	if (locale === "nl") return nl_payment_overdue_message(inputs)
	if (locale === "nb") return nb_payment_overdue_message(inputs)
	if (locale === "pl") return pl_payment_overdue_message(inputs)
	if (locale === "pt") return pt_payment_overdue_message(inputs)
	if (locale === "ro") return ro_payment_overdue_message(inputs)
	if (locale === "sk") return sk_payment_overdue_message(inputs)
	if (locale === "sl") return sl_payment_overdue_message(inputs)
	if (locale === "fi") return fi_payment_overdue_message(inputs)
	if (locale === "sv") return sv_payment_overdue_message(inputs)
	if (locale === "vi") return vi_payment_overdue_message(inputs)
	if (locale === "tr") return tr_payment_overdue_message(inputs)
	if (locale === "el") return el_payment_overdue_message(inputs)
	if (locale === "bg") return bg_payment_overdue_message(inputs)
	if (locale === "ru") return ru_payment_overdue_message(inputs)
	if (locale === "sr") return sr_payment_overdue_message(inputs)
	if (locale === "uk") return uk_payment_overdue_message(inputs)
	if (locale === "ka") return ka_payment_overdue_message(inputs)
	if (locale === "hi") return hi_payment_overdue_message(inputs)
	if (locale === "th") return th_payment_overdue_message(inputs)
	if (locale === "ko") return ko_payment_overdue_message(inputs)
	if (locale === "zh") return zh_payment_overdue_message(inputs)
	if (locale === "zh-tw") return zh_tw_payment_overdue_message(inputs)
	if (locale === "ja") return ja_payment_overdue_message(inputs)
	return en_payment_overdue_message(inputs)
});